import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35cf5205"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-template" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blankets" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-data" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("label", { for: "NomeCompleto" }, " Nome Completo "),
      /*#__PURE__*/_createElementVNode("input", {
        type: "text",
        id: "NomeCompleto",
        class: "input-padrao",
        required: ""
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email"),
      /*#__PURE__*/_createElementVNode("input", {
        type: "email",
        id: "email",
        class: "input-padrao",
        required: "",
        placeholder: "seuemail@dominio.com"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("label", { for: "telefone" }, "Telefone"),
      /*#__PURE__*/_createElementVNode("input", {
        type: "tel",
        id: "telefone",
        class: "input-padrao",
        required: "",
        placeholder: "(XX) XXXXX-XXXX"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("legend", null, "Como prefere nosso contato?"),
      /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
        /*#__PURE__*/_createElementVNode("label", { for: "radio-email" }, [
          /*#__PURE__*/_createElementVNode("input", {
            type: "radio",
            name: "contato",
            value: "email",
            id: "radio-email"
          }),
          /*#__PURE__*/_createTextVNode(" Email ")
        ]),
        /*#__PURE__*/_createElementVNode("label", { for: "radio-telefone" }, [
          /*#__PURE__*/_createElementVNode("input", {
            type: "radio",
            name: "contato",
            value: "telefone",
            id: "radio-telefone"
          }),
          /*#__PURE__*/_createTextVNode(" Telefone ")
        ]),
        /*#__PURE__*/_createElementVNode("label", { for: "radio-wpp" }, [
          /*#__PURE__*/_createElementVNode("input", {
            type: "radio",
            name: "contato",
            value: "wpp",
            id: "radio-wpp",
            checked: ""
          }),
          /*#__PURE__*/_createTextVNode(" WhatsApp ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("legend", null, "Qual turno prefere atendimento?"),
      /*#__PURE__*/_createElementVNode("div", { class: "attendance" }, [
        /*#__PURE__*/_createElementVNode("select", {
          name: "",
          id: ""
        }, [
          /*#__PURE__*/_createElementVNode("option", { value: "" }, "Manhã"),
          /*#__PURE__*/_createElementVNode("option", { value: "" }, "Tarde"),
          /*#__PURE__*/_createElementVNode("option", { value: "" }, "Noite")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("label", {
      for: "",
      class: "checkbox",
      x: ""
    }, [
      /*#__PURE__*/_createElementVNode("input", {
        type: "checkbox",
        checked: ""
      }),
      /*#__PURE__*/_createTextVNode(" Gostaria de receber nossas novidades por e-mail? ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "message" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "mensagem" }, "Mensagem"),
    /*#__PURE__*/_createElementVNode("textarea", {
      name: "",
      id: "mensagem",
      cols: "30",
      rows: "10",
      class: "input-padrao",
      required: ""
    })
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "submit",
  value: "Enviar Formulário",
  class: "enviar"
}, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, _hoisted_4))
}